import type { JSX } from "react";
import { Link } from "react-router";
import { Button } from "@/ui/button.js";
import { JobProgressCard } from "../../features/imports/JobProgressCard.js";
import { useImports } from "../../features/imports/useImport.js";

export function ImportsIndex(): JSX.Element {
  const { data, status, error } = useImports();

  return (
    <div className="mx-auto max-w-xl px-4 py-6 space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">Imports</h1>
        <Button asChild>
          <Link to="/imports/new">+ New import</Link>
        </Button>
      </div>

      {status === "loading" && (
        <p className="text-muted-foreground">Loading…</p>
      )}
      {status === "error" && (
        <p className="text-destructive">
          Failed to load imports: {error?.message ?? "unknown error"}
        </p>
      )}
      {status === "ready" && data.length === 0 && (
        <p className="text-muted-foreground">
          No imports yet. Tap "+ New import" to start.
        </p>
      )}

      <ul className="space-y-3">
        {data.map((j) => (
          <li key={j.id}>
            <Link to={`/imports/${encodeURIComponent(j.id)}`} className="block">
              <JobProgressCard job={j} />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
